import { render, staticRenderFns } from "./imageUploadInGallery.vue?vue&type=template&id=28a58749&scoped=true"
import script from "./imageUploadInGallery.vue?vue&type=script&lang=js"
export * from "./imageUploadInGallery.vue?vue&type=script&lang=js"
import style0 from "./imageUploadInGallery.vue?vue&type=style&index=0&id=28a58749&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a58749",
  null
  
)

export default component.exports